import { Component, Input, OnInit } from '@angular/core';
import { ProductsContainerDto, ProductsGroupDto } from '../../eso.service';
import { NetworkDeepDiveComponent } from '../network-deep-dive.component';

@Component({
    selector: 'app-eso-network-deep-dive-products-group',
    templateUrl: './eso-network-deep-dive-products-group.component.html',
    styleUrls: ['./eso-network-deep-dive-products-group.component.scss'],
    standalone: false
})
export class EsoNetworkDeepDiveProductsGroupComponent implements OnInit {

	@Input() pageComponent: NetworkDeepDiveComponent;
	@Input() sourcingData: ProductsContainerDto;
	@Input() productsGroup: ProductsGroupDto;
	@Input() isInput: boolean;

	@Input() public decimalPipeExpression: string;

	constructor() { }

	ngOnInit() {
	}
}